import { Component, Input, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import {
  LAYOUT_NAME,
  MIN_STATUS,
  SIGN_IN_NAME,
} from '../../../../../shared/utils/constants';
import { SignatureSectionModel } from '../../../../models/signature-section.model';
import { NotaryAddress, SignatureModel } from '../../../../models/signature.model';
import { DashboardSectionService } from '../../../../services/dashboard-section/dashboard-section.service';
import { MortgageService } from '../../../../services/mortgage/mortgage.service';
import { SignatureService } from '../../../../services/signature/signature.service';

@Component({
  selector: 'app-signature-section',
  templateUrl: './signature-section.component.html',
  styleUrls: ['./signature-section.component.scss'],
  standalone: false,
  //   changeDetection: ChangeDetectionStrategy.OnPush
})
export class SignatureSectionComponent implements OnInit {
  // @Input() status: number;
  _status: number;
  get status(): number {
    return this._status;
  }

  @Input('status')
  set status(value: number) {
    this._status = value;
    this.getSignatureData();
  }

  @Input() isRejected: boolean;

  public SIGN_IN_NAME = SIGN_IN_NAME;
  public LAYOUT_NAME = LAYOUT_NAME;
  public minStatus = MIN_STATUS;

  public signatureState: SignatureSectionModel;
  public address: string;
  public httpError: boolean = false;
  public showInfo: boolean = false;

  constructor(
    private dashboardSectionService: DashboardSectionService,
    private translate: TranslateService,
    private mortgageService: MortgageService,
    private signatureService: SignatureService,
  ) {}

  ngOnInit() {}

  private getSignatureData() {
    if (this.status >= this.minStatus.signature) {
      this.dashboardSectionService.getSignatureSectionData().subscribe(
        (response) => {
          this.signatureState = response;
          if (
            response.notaryAddress === null ||
            response.notaryName === null ||
            response.signatureDate === null || // Siempre viene vacía
            response.signatureTime === null
          ) {
            this.updateSignatureData();
          } else {
            this.address = this.concatAddress(response['notaryAddress']);
            this.showInfo =
              !!this.signatureState.notaryName &&
              !!this.address &&
              // !!this.signatureState.signatureDate && // siempre viene vacía
              !!this.signatureState.signatureTime;
          }
        },
        (error) => {
          this.httpError = true;
        },
      );
    }
  }

  /**
   * Puede que el witget de firma no tenga los datos aún, para forzar a que los actualice se debe hacer una petición al servicio de firma
   */
  updateSignatureData() {
    this.signatureService.getSignatureData().subscribe(
      (response) => {
        this.mapResponseSignature(response);
      },
      (error) => {
        this.httpError = true;
      },
    );
  }

  mapResponseSignature(signatureData: SignatureModel) {
    this.signatureState.notaryName =
      signatureData.mortgagesSignCrmData.mortgageNotaryData.notaryName;
    this.signatureState.signatureDate = signatureData.mortgagesSignCrmData.signatureDate;
    this.signatureState.signatureTime = signatureData.mortgagesSignCrmData.signatureTime;
    this.signatureState.notaryAddress =
      signatureData.mortgagesSignCrmData.mortgageNotaryData.notaryAddress;
    this.address = this.concatAddress(this.signatureState.notaryAddress);
    this.showInfo =
      !!this.signatureState.notaryName &&
      !!this.address &&
      !!this.signatureState.signatureDate &&
      !!this.signatureState.signatureTime;
  }

  private concatAddress(address: NotaryAddress) {
    let street = address.roadType ? this.translate.instant(address.roadType) : '';
    if (address.roadName) {
      street = `${street} ${address.roadName}`;
    }
    if (address.roadNumber) {
      street = `${street}, ${address.roadNumber}`;
    }
    if (address.door) {
      street = `${street} ${address.door}`;
    }
    if (address.zip) {
      street = `${street}, ${address.zip}`;
    }
    const province = this.mortgageService.findProvince(address.province);
    if (
      address.city &&
      address.city.toLocaleLowerCase() === province.toLocaleLowerCase()
    ) {
      street = `${street} ${address.city}`;
    } else if (address.city) {
      street = `${street} ${address.city}, ${province}`;
    }
    return street;
  }
}
